import { ComponentWithAs, createIcon, IconProps } from '@chakra-ui/react';

export const ChevronDownIcon: ComponentWithAs<'svg', IconProps> = createIcon({
  displayName: 'ChevronDownIcon',
  viewBox: '0 0 18 18',
  defaultProps: {
    fill: 'none',
  },
  path: (
    <path
      d="M15.5 6L9 12.5L2.5 6"
      stroke="#959595"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});
